<template>
  <div>
    <panel title="Konkursy">
      <w-table
        entity-type="contest"
        :hide-search-input="false"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />
    </panel>

    <contest-modal :id="idToEdit" :show="showModal" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ContestModal from '@/components/modals/ContestModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { ContestType, contestTypeTranslation } from '@/enums/contestType.enum';
import { SchoolLevel, schoolLevelTranslation } from '@/enums/schoolLevel.enum';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania konkursów.',
  getError: 'Wystąpił błąd podczas pobierania danych konkursu.',
  added: 'Dodano konkurs.',
  addError: 'Nie udało się dodać konkursu.',
  updated: 'Zaktualizowano dane konkursu.',
  updateError: 'Nie udało się zaktualizować danych konkursu.',
  deleteConfirm: 'Czy na pewno chcesz usunąć konkurs?',
  deleted: 'Usunięto konkurs.',
  deleteError: 'Nie udało się usunąć konkursu.'
};

// @vuese
// Lista Konkursów
// @group contest
export default {
  components: { Panel, WTable, ContestModal },
  mixins: [listMixin('contest', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true },
      {
        name: 'type',
        displayName: 'Typ',
        sortable: true,
        nameTransformer: type => contestTypeTranslation[ContestType[type]]
      },
      {
        name: 'level',
        displayName: 'Poziom',
        sortable: true,
        nameTransformer: level => schoolLevelTranslation[SchoolLevel[level]]
      }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  }),
  methods: {
    // @vuese
    // Filtry listy
    getFilters(route) {
      return {
        count: tryParseInt(route.query.count),
        start: tryParseInt(route.query.start),
        search: route.query.search
      };
    }
  }
};
</script>
